import { ReactElement, ReactNode } from "react"
import { useParams } from "react-router-dom"

import AmendEbDeviceProvider from "./baseProviders/amendEbDeviceProvider"
import useContinueEbDeviceDraft from "../../../../../services/middleware/hooks/devices/lct/useContinueEbDeviceDraft"

interface IContinueEbDeviceAmendmentUrlParams {
    deviceRef: string
}

interface IContinueEbDeviceAmendmentProviderProps {
    children: ReactNode
}

const ContinueEbDeviceAmendmentProvider = ({
    children,
}: IContinueEbDeviceAmendmentProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof IContinueEbDeviceAmendmentUrlParams
    >() as IContinueEbDeviceAmendmentUrlParams

    const {
        data: formData,
        setData: setFormData,
        isLoading,
        error: continueAmendmentError,
        attachmentUUID,
        apiResSystemRef,
    } = useContinueEbDeviceDraft(urlDeviceRef)

    return (
        <AmendEbDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={continueAmendmentError}
            attachmentUUID={attachmentUUID ?? undefined}
            systemReference={apiResSystemRef ?? "Not loaded"}
        >
            {children}
        </AmendEbDeviceProvider>
    )
}

export default ContinueEbDeviceAmendmentProvider
